import { createSlice, PayloadAction } from "@reduxjs/toolkit";


import { ValuationData } from "../Types/ValuationEdit/ValuationEditInterface";
import { getValuationEditDataByFolder } from "../Thunks/ValuationEditThunks";

interface ValuationEditSliceState {
    loader: boolean; // for refres pages and inital loadings
    valuationEditData: ValuationData|null;
    errorDisplay: string | null;
}

// set inital valus
const initialState : ValuationEditSliceState = {
    loader: false,
    valuationEditData:null,
    errorDisplay: '',

}

// set state valu for api response
const valuationEditSlice = createSlice ({
    name: 'valuationEditSlice',
    initialState,
    reducers : {
    },
    extraReducers(builder){
        builder.addCase(getValuationEditDataByFolder.rejected, (state, action) => {
                    state.loader = false;
                    state.errorDisplay = action.error.message!;
                  })
                    .addCase(getValuationEditDataByFolder.pending, state => {
                    state.loader = true;
                    state.errorDisplay = null;
                  })
                  .addCase(getValuationEditDataByFolder.fulfilled, (state, action: PayloadAction<ValuationData>) => {
                    state.loader = false;
                    state.valuationEditData = action.payload;
                  })
    }
})

export const {} = valuationEditSlice.actions
export default valuationEditSlice.reducer
